import { THEMES, type ResolvedTheme, type Theme } from '@/types/theme';

export const getResolvedTheme = (theme: Theme): ResolvedTheme => {
  if (theme !== 'system') {
    return theme;
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
};

export const applyTheme = (theme: Theme): void => {
  document.documentElement.setAttribute('data-theme', getResolvedTheme(theme));
};

const readStorageItem = (storageKey: string): string | null => {
  try {
    return localStorage.getItem(storageKey);
  } catch {
    return null;
  }
};

export const readStoredTheme = (storageKey: string): Theme => {
  const stored = readStorageItem(storageKey);
  if (stored && (THEMES as readonly string[]).includes(stored)) {
    return stored as Theme;
  }

  return 'system';
};

export const storeTheme = (storageKey: string, theme: Theme): void => {
  try {
    localStorage.setItem(storageKey, theme);
  } catch {
    return;
  }
};
